<div class="Container Flexbox Flexbox--column Gap--normal">
  <h2 class="Title">Explore Designs</h2>
  <app-design-search [availableDesigns]="reachableDesigns()" (filteredDesignsChange)="filteredDesigns.set($event)" (filteredCategoriesChange)="filteredCategories.set($event)"></app-design-search>
  @for (category of categoriesToShow(); track $index) {
    <div class="DesignGroup Grid Gap--smaller">
      <h3 class="DesignGroupTitle">{{ category.name }}</h3>
      @for (design of getDesignsInCategory(category.id); track $index) {
        <div class="DesignCell Flexbox Flexbox--column">
          <app-design-card [design]="design" (designClick)="designClick($event)" [isSelected]="selectedDesign()?.id === design.id" [isAvailable]="reachableDesigns().includes(design.id)"></app-design-card>
          @if (designsWithStyleImages().includes(design.id)) {
            <button mat-button class="ViewMoreButton" (click)="viewExamples(design)">View Examples</button>
          }
          </div>
      }
    </div>
  }
</div>
